"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseKontentResponseArrayDebug = exports.BaseKontentResponseStandardDebug = exports.BaseKontentResponse = void 0;
var staleContentHeaderName = 'X-Stale-Content';
function getHasStaleContent(response) {
    var hasStaleContentHeader = response.headers.find(function (m) { return m.header.toLowerCase() === staleContentHeaderName.toLowerCase(); });
    if (hasStaleContentHeader) {
        if (hasStaleContentHeader.value.toString() === '1') {
            return true;
        }
    }
    return false;
}
function getResponseDebug(response) {
    return {
        response: response.response,
        headers: response.headers,
        status: response.status
    };
}
var BaseKontentResponse = /** @class */ (function () {
    function BaseKontentResponse() {
    }
    return BaseKontentResponse;
}());
exports.BaseKontentResponse = BaseKontentResponse;
var BaseKontentResponseStandardDebug = /** @class */ (function (_super) {
    __extends(BaseKontentResponseStandardDebug, _super);
    function BaseKontentResponseStandardDebug(response, isDeveloperMode) {
        var _this = _super.call(this) || this;
        _this.hasStaleContent = getHasStaleContent(response);
        _this.isDeveloperMode = isDeveloperMode;
        if (isDeveloperMode) {
            _this.debug = getResponseDebug(response);
        }
        return _this;
    }
    return BaseKontentResponseStandardDebug;
}(BaseKontentResponse));
exports.BaseKontentResponseStandardDebug = BaseKontentResponseStandardDebug;
var BaseKontentResponseArrayDebug = /** @class */ (function (_super) {
    __extends(BaseKontentResponseArrayDebug, _super);
    function BaseKontentResponseArrayDebug(responses, isDeveloperMode) {
        var _this = _super.call(this) || this;
        _this.debug = [];
        /**
         * Always false for joined response data
         */
        _this.hasStaleContent = false;
        _this.isDeveloperMode = isDeveloperMode;
        if (isDeveloperMode) {
            for (var _i = 0, responses_1 = responses; _i < responses_1.length; _i++) {
                var response = responses_1[_i];
                if (_this.debug) {
                    _this.debug.push(getResponseDebug(response));
                }
            }
        }
        return _this;
    }
    return BaseKontentResponseArrayDebug;
}(BaseKontentResponse));
exports.BaseKontentResponseArrayDebug = BaseKontentResponseArrayDebug;
//# sourceMappingURL=base-responses.js.map